<template>
  <div id="reserva">
    <vue-headful :title="$store.state.option['car_title-' + lang]" :lang="lang" />
    <titulo></titulo>

    <div class="b-laranja p-10">
      <div class="container">
        <div class="row">
          <div class="quadrado text-justify pr col-md-3 col-lg-3 col-sm-12 col-xs-12 p-0">
            <div class="seta b-laranja"></div>
            <div class="p-20 b-branco quadrado1 m-r-10">
              <div class="branco redondo b-laranja">01</div> {{$store.state.option['reserved-escolhaCarro-' + lang]}}
            </div>
          </div>
          <div class="quadrado text-justify pr col-md-3 col-lg-3 col-sm-12 col-xs-12 p-0">
            <div class="seta b-laranja"></div>
            <div class="p-20 b-branco quadrado1 m-r-10">
              <div class="branco redondo b-laranja">02</div> {{$store.state.option['reserved-detalhesReserva-' + lang]}}
            </div>
          </div>
          <div class="quadrado text-justify pr col-md-3 col-lg-3 col-sm-12 col-xs-12 p-0">
            <div class="seta b-laranja"></div>
            <div class="p-20 b-branco quadrado1 m-r-10">
              <div class="branco redondo b-laranja">03</div> {{$store.state.option['reserved-pagamento-' + lang]}}
            </div>
          </div>
          <div class="quadrado text-justify pr col-md-3 col-lg-3 col-sm-12 col-xs-12 p-0">
            <div class="p-20 b-branco quadrado1 m-r-10">
              <div class="branco redondo b-laranja">04</div> {{$store.state.option['reserved-boaViagem-' + lang]}}
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>
    </div>

    <div class="container m-b-20 m-t-20">
      <h2 class="text-success text-center p-50">{{$store.state.option['reserved-reserva-sucesso-n-' + lang]}} <span class="laranja">{{reserva}}</span>.
        <br />
        <a downlaod v-if="link" :href="link" class="float-right btn btn-warning">{{$store.state.option['reserved-download-pdf-' + lang]}}</a>
      </h2>
    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import titulo from '@/components/titulo'

export default {
  components: { titulo },
  data () {
    return {
      lang: '',
      link: '',
      reserva: '',
      token: ''
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_LOAD',
      'SET_LOAD1',
      'SET_TITULO',
      'SET_SUBTITULO',
      'SET_AVISO'
    ]),
    init () {
      if (this.$store.state.option1 && this.$store.state.user1) {
        this.reserva = parseInt(window.location.search.split('id=')[1])
        this.token = window.location.search.split('&token=')[1]
        this.lang = this.$store.state.lang
        this.link = '/pdf/' + this.reserva + '/' + this.token + '?language=' + this.lang
        this.SET_TITULO(this.$store.state.option['confirmed_title-' + this.lang])
        this.SET_SUBTITULO(this.$store.state.option['confirmed_subtitle-' + this.lang])
        this.SET_LOAD()
        this.SET_LOAD1()
      } else {
        this._.delay(this.init, 100)
      }
    }
  }
}
</script>
